import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form, Icon } from 'semantic-ui-react';
import { useParams, useNavigate } from 'react-router-dom';
import { API, downloadTextAsFile, showError, showSuccess } from '../../helpers';
import { renderQuota, renderQuotaWithPrompt } from '../../helpers/render';
import globalStyles from '../../styles/globalStyles';

const EditRedemption = () => {
  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();
  const redemptionId = params.id;
  const isEdit = redemptionId !== undefined;
  const [loading, setLoading] = useState(isEdit);
  const originInputs = {
    name: '',
    quota: 100000,
    count: 1,
  };
  const [inputs, setInputs] = useState(originInputs);
  const { name, quota, count } = inputs;

  const handleCancel = () => {
    navigate('/redemption');
  };

  const handleInputChange = (e, { name, value }) => {
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  const loadRedemption = async () => {
    let res = await API.get(`/api/redemption/${redemptionId}`);
    const { success, message, data } = res.data;
    if (success) {
      setInputs(data);
    } else {
      showError(message);
    }
    setLoading(false);
  };
  useEffect(() => {
    if (isEdit) {
      loadRedemption().then();
    }
  }, []);

  const submit = async () => {
    if (!isEdit && inputs.name === '') return;
    let localInputs = inputs;
    localInputs.count = parseInt(localInputs.count);
    localInputs.quota = parseInt(localInputs.quota);
    let res;
    if (isEdit) {
      res = await API.put(`/api/redemption/`, {
        ...localInputs,
        id: parseInt(redemptionId),
      });
    } else {
      res = await API.post(`/api/redemption/`, {
        ...localInputs,
      });
    }
    const { success, message, data } = res.data;
    if (success) {
      if (isEdit) {
        showSuccess(t('redemption.messages.update_success'));
      } else {
        showSuccess(t('redemption.messages.create_success'));
        setInputs(originInputs);
      }
    } else {
      showError(message);
    }
    if (!isEdit && data) {
      let text = '';
      for (let i = 0; i < data.length; i++) {
        text += data[i] + '\n';
      }
      downloadTextAsFile(text, `${inputs.name}.txt`);
    }
  };

  return (
    <div style={globalStyles.page}>
      <div style={globalStyles.card}>
        <div style={{ ...globalStyles.hero, marginBottom: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Icon name='edit' style={{ color: '#18181b', fontSize: 22, margin: 0 }} />
            <span style={{ fontSize: 20, fontWeight: 800, color: '#18181b' }}>
              {isEdit ? t('redemption.edit.title_edit') : t('redemption.edit.title_create')}
            </span>
          </div>
        </div>
        <Form loading={loading} autoComplete='new-password'>
          <Form.Field>
            <Form.Input
              label={t('redemption.edit.name')}
              name='name'
              placeholder={t('redemption.edit.name_placeholder')}
              onChange={handleInputChange}
              value={name}
              autoComplete='new-password'
              required={!isEdit}
              style={{ borderRadius: 10 }}
            />
          </Form.Field>
          <Form.Field>
            <Form.Input
              label={`${t('redemption.edit.quota')}${renderQuotaWithPrompt(quota, t)}`}
              name='quota'
              placeholder={t('redemption.edit.quota_placeholder')}
              onChange={handleInputChange}
              value={quota}
              autoComplete='new-password'
              type='number'
              style={{ borderRadius: 10 }}
            />
          </Form.Field>
          {!isEdit && (
            <>
              <Form.Field>
                <Form.Input
                  label={t('redemption.edit.count')}
                  name='count'
                  placeholder={t('redemption.edit.count_placeholder')}
                  onChange={handleInputChange}
                  value={count}
                  autoComplete='new-password'
                  type='number'
                  style={{ borderRadius: 10 }}
                />
              </Form.Field>
            </>
          )}
          <Button positive onClick={submit} style={globalStyles.primaryButton}>
            {t('redemption.edit.buttons.submit')}
          </Button>
          <Button onClick={handleCancel} style={{ ...globalStyles.button, background: 'rgba(0,0,0,0.03)', color: '#374151' }}>
            {t('redemption.edit.buttons.cancel')}
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default EditRedemption;
